<template>
  <DataGetter
    @dataAvailable="
      data => {
        categories = data?.metaData?.categories
      }
    "
    contentId="categories"
  />
  <div>
    <div class="grid grid-cols-1 md:grid-cols-5 gap-4">
      <!-- Section Informations générales -->
      <div class="md:col-span-3 border bg-white rounded-3xl p-4">
        <h1 class="text-lg font-bold title-color">Informations Générales</h1>
        <div class="py-2"></div>
        <div>
          <div>Nom du plat</div>
          <div class="text-lg title-color">
            {{ formData.name }}
          </div>
        </div>
        <div class="py-2"></div>
        <div>
          <div>Description du plat</div>
          <div class="text-lg title-color">
            {{ formData.description }}
          </div>
        </div>
      </div>

      <!-- Section Media -->
      <div class="md:col-span-2 border bg-white rounded-3xl p-4 flex flex-col">
        <h1 class="text-lg font-bold title-color">Images du plat</h1>
        <div class="py-2"></div>
        <div
          class="h-full border-2 border-dashed rounded-3xl p-4 flex flex-col relative"
        >
          <div
            class="text-center top-1 left-0 absolute w-full pointer-events-none"
          >
            Image Principale
          </div>
          <div class="w-full h-full py-5">
            <div class="flex justify-center gap-3 h-full">
              <img
                v-if="formData.image"
                class="w-1/2 md:w-1/3 h-full object-contain rounded-2xl bg-slate-100 border overflow-hidden"
                :src="formData.image"
                alt=""
              />
            </div>
          </div>
        </div>
        <div class="py-2"></div>
        <div
          class="h-full border-2 border-dashed rounded-3xl p-4 flex flex-col relative"
        >
          <div
            class="text-center top-1 left-0 absolute w-full pointer-events-none"
          >
            Images Secondaires
          </div>
          <div
            class="w-full overflow-auto h-full py-5"
            v-if="formData.images?.length"
          >
            <div class="flex min-w-max gap-3 h-full">
              <div
                class="relative w-[10rem] h-full group"
                v-for="(image, i) in formData.images"
                :key="i"
                @mouseover="hoveredImageIndex = i"
                @mouseleave="hoveredImageIndex = null"
              >
                <img
                  class="w-full h-full object-contain rounded-2xl bg-slate-100 border overflow-hidden"
                  :src="image"
                  alt=""
                />
              </div>
            </div>
          </div>
          <div v-else class="text-center text-xl pt-4 font-bold">
            Aucune image Secondaire
          </div>
        </div>
      </div>

      <!-- Section Pricing -->
      <div class="md:col-span-3 border bg-white rounded-3xl p-4">
        <h1 class="text-lg font-bold title-color">Prix</h1>
        <div class="py-2"></div>
        <div>Montant : {{ formData.price }} XOF</div>
        <div class="py-2"></div>
        <h1 class="text-lg font-bold title-color">En Stock</h1>
        <div class="py-2"></div>
        <div>Quantité : {{ formData.quantity }}</div>
      </div>

      <!-- Section Catégorie -->
      <div class="md:col-span-2 border bg-white rounded-3xl p-4">
        <h1 class="text-lg font-bold title-color">Catégorie</h1>
        <div class="py-2"></div>
        {{ formData.category }}
        <div class="py-2"></div>
        <h1 class="text-lg font-bold title-color">Sous-Catégorie</h1>
        <div class="py-2"></div>
        {{ formData.subcategory }}
      </div>

      <div
        class="md:col-span-5 border bg-white rounded-3xl p-4"
        v-if="formData.categoryId !== 'digital'"
      >
        <h1 class="text-lg font-bold title-color">Details spécifics</h1>
        <div class="py-2"></div>
        <div class="grid grid-cols-3 gap-x-4">
          <InputComponent
            required
            label="Marque"
            type="text"
            disabled
            placeHolder="La marque du produit"
            v-model="formData.brand"
          />
          <InputComponent
            required
            label="Matériel"
            type="text"
            disabled
            placeHolder="Matériel de construction du produit"
            v-model="formData.material"
          />
          <InputComponent
            required
            label="Etat"
            type="text"
            disabled
            placeHolder="Neuv, Deuxième main, ..."
            v-model="formData.condition"
          />
        </div>
      </div>
    </div>

    <div class="py-4"></div>
    <div class="flex justify-center gap-12">
      <button
        type="submit"
        class="buttonComponent"
        @click="publishProduct"
        v-if="!formData.isPublished"
      >
        Valider
      </button>
      <button
        type="submit"
        class="buttonComponent bg-transparent border border-primary text-primary"
        @click="rejectProduct"
        v-if="!formData.isPublished"
      >
        Rejeter
      </button>
      <button
        type="submit"
        class="buttonComponent "
        @click="unpublishProduct"
        v-if="formData.isPublished"
      >
        Dépublier
      </button>
    </div>
    <div class="pb-12"></div>
    <EventListener
      :events="['product_published', 'product_unpublished']"
      @product_published="
        () => {
          $router.back()
        }
      "
      @product_unpublished="
        () => {
          $router.back()
        }
      "
    />
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import InputComponent from '../utils/InputComponent.vue'
import DataGetter from '../utils/DataGetter.vue'
import EventListener from '../utils/EventListener.vue'

export default defineComponent({
  name: 'ProductForm',
  components: { EventListener, InputComponent, DataGetter },
  props: {
    initialData: {
      type: Object,
      default: () => ({
        name: '',
        description: '',
        price: null,
        category: '',
        subCategory: '',
        quantity: null,
        colors: [],
        images: [],
      }),
    },
    isEditing: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      formData: { ...this.initialData },
      filePikerId: 'test',
      hoveredColorIndex: null,
      hoveredImageIndex: null,
      categories: [],
    }
  },
  methods: {
    toogleProductPublishing() {
      this.$Events.dispatchEvent(
        'wanted_to_toggle_product_publishing',
        this.formData,
      )
    },
    publishProduct() {
      this.$Events.dispatchEvent('wanted_to_publish_product', this.formData)
    },
    unpublishProduct() {
      this.$Events.dispatchEvent('wanted_to_unpublish_product', this.formData)
    },
    rejectProduct() {
      this.$Events.dispatchEvent('wanted_to_reject_product', this.formData)
    },
  },
})
</script>

<style scoped></style>
